import PropTypes from 'prop-types';
import React from 'react';

import {
  QUERY_PARAM_KEYS,
  QUERY_PARAM_VALUES,
} from '../../../constants/massOfferings/queryParamKeys';
import { useSearchParams } from '../../../hooks/useSearchParams';
import { AfterTransaction } from '../../MassOfferings';
import { AddDevotionOffering } from '../AddDevotionOffering/AddDevotionOffering';

export const DevotionOfferingsContent = ({ devotionsDictionary, inboxDictionary }) => {
  const urlSearchParams = useSearchParams();

  const isFromTransaction =
    urlSearchParams.get(QUERY_PARAM_KEYS.source) === QUERY_PARAM_VALUES.TRANSACTION;

  return isFromTransaction ? (
    <AfterTransaction />
  ) : (
    <AddDevotionOffering
      devotionsDictionary={devotionsDictionary}
      inboxDictionary={inboxDictionary}
    />
  );
};

DevotionOfferingsContent.propTypes = {
  devotionsDictionary: PropTypes.array.isRequired,
  inboxDictionary: PropTypes.array.isRequired,
};
